exports = module.exports = require("../node_modules/.0.21.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".accordion-toggle {\n  cursor: pointer;\n}\n.collapse-transition {\n  transition: max-height .5s ease;\n}\n.collapse-enter, .collapse-leave {\n  max-height: 0!important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.21.0@css-loader!./~/.7.1.7@vue-loader/lib/style-rewriter.js?id=_v-1f98aa02&file=Panel.vue!./~/.7.1.7@vue-loader/lib/selector.js?type=style&index=0!./src/Panel.vue
// module id = 157
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///src/Panel.vue?8195